export default {
  path: '/dashboard',
  component: () => import('../../views/dashBoard/dashboard-router.vue'),
  children: [
    {
      path: '',
      name: 'DashBoard',
      component: () => import('@/views/dashBoard/pages/DashBoard.vue'),
      meta: {
        name: 'navigationDrawer.dashBoard',
        icon: '/icons/dashboard.svg',
        auth: true,
        role: 'owner'
      }
    }

  ]
}
